/**
 * How wide operations console pages grow (owner decision, 2026-09-28): the whole window on any
 * laptop, with a 1920px cap only on large external monitors. Prose keeps its own reading width.
 */
export const PAGE_WIDTH = "max-w-[120rem]";
